module.exports = __webpack_public_path__ + "img/product-banner_10.d06c755f.png";